import { createContext } from "react";
import { BuildCampaignPageController } from "../controllers/media-planner/build-campaign-controller";

export const BuildCampaignContext = createContext<
  BuildCampaignPageController | undefined
>(undefined);
